import { mutations as types } from './types';

const mutations = {
  [types.SEARCH_RESULT](state: any, data: any) {
    state.articleSearch.searchResult = data;
  },
  [types.TUTORIAL_PLAYLIST_BY_CATEGORY](state: any, data: any) {
    state.categorySearch.playList = data;
  },
  [types.CURRENT_LAYOUT](state: any, data: any) {
    state.currentLayout = data;
  },
  [types.CALLING_API](state: any, data: any) {
    state.isApiCalling = data;
  },
  [types.SHOW_MODAL](state: any) {
    state.isShowModal = true;
  },
  [types.HIDE_MODAL](state: any) {
    state.isShowModal = false;
  },
  [types.TOGGLE_MODAL](state: any) {
    state.isShowModal = !state.isShowModal;
  },
  [types.SHOW_ICON](state: any) {
    state.isShowIcon = true;
  },
  [types.HIDE_ICON](state: any) {
    state.isShowIcon = false;
  },
  [types.MOMENT_OPEN](state: any) {
    state.momentOpen = new Date().getTime();
  },
  [types.MOMENT_CLOSE](state: any) {
    state.momentClose = new Date().getTime();
  },
  [types.ACCOUNT_UPDATE_GETHELP_DATA](state: any, data: any) {
    state.gethelp = data;
  },
};

export default mutations;
